module.exports = " <div class=WidgetCenterColumn> <div class=WidgetCenterColumn__container> <slot></slot> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/columns/WidgetCentercolumn.vue
// module id = 485
// module chunks = 1